var React = require('react');

function IconHeartSolidInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"d":"M19.61 6.33a4.89 4.89 0 00-6.7 0L12 7.2l-.92-.87a4.89 4.89 0 00-6.7 0 4.38 4.38 0 000 6.4l.93.87L12 20l6.7-6.4.91-.88a4.38 4.38 0 000-6.4","id":"icon_heart_solid_inline"})),React.createElement("use",{"fill":"currentColor","xlinkHref":"#icon_heart_solid_inline","transform":"translate(-3 -5)","fillRule":"evenodd","key":1})]);
}

IconHeartSolidInline.defaultProps = {"width":"18","height":"15"};

module.exports = IconHeartSolidInline;

IconHeartSolidInline.default = IconHeartSolidInline;
